module.exports = __webpack_public_path__ + "static/media/store.a563b240.svg";